// client/globals/events.ts
import { Event } from "./enums.js";
var ThrowEventSetEditContent = (host, value) => {
  host.dispatchEvent(new CustomEvent(Event.SET_EDIT_CONTENT, { detail: { value, host }, composed: true }));
};
var ThrowEventSetContent = (host, value) => {
  host.dispatchEvent(new CustomEvent(Event.SET_CONTENT, { detail: { value }, composed: true }));
};
var ThrowEventUpdateContent = (host) => {
  host.dispatchEvent(new CustomEvent(Event.UPDATE_CONTENT, { composed: true }));
};
var ThrowEventDraggingChanged = (host, value) => {
  host.dispatchEvent(new CustomEvent(Event.DRAGGING_CHANGED, { detail: { value, host }, composed: true }));
};
var ThrowEventCopyToClipboard = (host, value) => {
  host.dispatchEvent(new CustomEvent(Event.COPY_TO_CLIPBOARD, { detail: { value }, composed: true }));
};
var ThrowEventSizeChanged = (host, value) => {
  host.dispatchEvent(new CustomEvent(Event.SIZE_CHANGED, { detail: { value }, composed: true }));
};
var ThrowEventMoveToAnchor = (host, value) => {
  host.dispatchEvent(new CustomEvent(Event.MOVE_TO_ANCHOR, { detail: { value }, composed: true }));
};
export {
  ThrowEventCopyToClipboard,
  ThrowEventDraggingChanged,
  ThrowEventMoveToAnchor,
  ThrowEventSetContent,
  ThrowEventSetEditContent,
  ThrowEventSizeChanged,
  ThrowEventUpdateContent
};
